import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// OrderReviewSheet — bước XÁC NHẬN lệnh (Pha 1 trust fixes, TICKET_TRUST_2026-10-24).
// Dumb presentational: nhận view-model đã tính sẵn + 2 callback, KHÔNG tự validate,
// KHÔNG tự tính toán ⇒ dock và modal hiển thị giống hệt nhau, không drift.
import { useEffect, useRef } from "react";
import { useWidgetI18n } from "../../context/WidgetI18nContext";
import { formatOrderTypeLabel } from "./orderTicketModel";
import styles from "./OrderTicketModal.module.css";
function formatNumber(value) {
    if (value == null || !Number.isFinite(value))
        return null;
    return value.toLocaleString("en-US");
}
export function OrderReviewSheet({ review, onConfirm, onCancel, confirmDisabled, disabledReason }) {
    const { t, locale } = useWidgetI18n();
    // O6: khi review mở, nút submit đã unmount ⇒ focus rơi về body. Đưa focus vào
    // chính sheet để screen-reader đọc được tóm tắt trước khi user bấm.
    const sheetRef = useRef(null);
    useEffect(() => {
        sheetRef.current?.focus();
    }, []);
    const sideLabel = review.side === "buy"
        ? t("widget.trading.buy", { defaultValue: "Buy" })
        : t("widget.trading.sell", { defaultValue: "Sell" });
    const rows = [
        { key: "side", label: t("widget.trading.side", { defaultValue: "Side" }), value: sideLabel },
        { key: "symbol", label: t("widget.trading.symbol", { defaultValue: "Symbol" }), value: review.symbol },
        {
            key: "type",
            label: t("widget.trading.orderType", { defaultValue: "Order type" }),
            value: formatOrderTypeLabel(review.type, locale === "en" ? "en" : "vi"),
        },
        {
            key: "quantity",
            label: t("widget.trading.quantity", { defaultValue: "Quantity" }),
            value: formatNumber(review.quantity) ?? "-",
        },
        {
            key: "price",
            label: t("widget.trading.price", { defaultValue: "Price" }),
            value: formatNumber(review.price) ?? "-",
        },
        {
            key: "notional",
            label: t("widget.trading.orderValue", { defaultValue: "Order value" }),
            value: formatNumber(review.notional) ?? "-",
            testId: "order-review-notional",
        },
    ];
    const tp = formatNumber(review.takeProfitPrice);
    if (tp)
        rows.push({ key: "tp", label: t("widget.trading.takeProfit", { defaultValue: "Take profit" }), value: tp });
    const sl = formatNumber(review.stopLossPrice);
    if (sl)
        rows.push({ key: "sl", label: t("widget.trading.stopLoss", { defaultValue: "Stop loss" }), value: sl });
    const margin = formatNumber(review.requiredMargin);
    if (margin) {
        rows.push({
            key: "margin",
            label: t("widget.trading.requiredMargin", { defaultValue: "Required margin" }),
            value: margin,
        });
    }
    rows.push({
        key: "buyingPower",
        label: t("widget.trading.buyingPower", { defaultValue: "Buying power" }),
        value: formatNumber(review.buyingPower) ?? "-",
    });
    return (_jsxs("div", { className: styles.review, "data-testid": "order-review", ref: sheetRef, tabIndex: -1, children: [_jsx("div", { className: styles.reviewTitle, children: t("widget.trading.reviewTitle", { defaultValue: "Confirm order" }) }), _jsx("dl", { className: styles.reviewRows, children: rows.map((row) => (_jsxs("div", { className: styles.reviewRow, children: [_jsx("dt", { className: styles.reviewLabel, children: row.label }), _jsx("dd", { className: styles.reviewValue, "data-testid": row.testId, children: row.value })] }, row.key))) }), disabledReason ? (_jsx("div", { className: styles.error, "data-testid": "order-review-error", children: disabledReason })) : null, _jsxs("div", { className: styles.reviewActions, children: [_jsx("button", { type: "button", "data-testid": "order-review-cancel", onClick: onCancel, children: t("widget.trading.cancel", { defaultValue: "Cancel" }) }), _jsx("button", { type: "button", "data-testid": "order-review-confirm", className: review.side === "buy" ? styles.submitBuy : styles.submitSell, disabled: confirmDisabled, onClick: onConfirm, children: t("widget.trading.confirm", { defaultValue: "Confirm" }) })] })] }));
}
